import React, { FC } from 'react';
import { BulletList, IContentLoaderProps } from 'react-content-loader';

export const ConsentListSkeleton: FC<IContentLoaderProps> = () => (
  <BulletList
    animate
    backgroundColor={'#EDEDED'}
    foregroundColor={'#D9D9D9'}
    style={{ display: 'block', width: '100%' }}
    speed={2}
  />
);
